export const formFields = [
  {
    section: "Section 1",
    name: "bscScheduleName",
    label: "Schedule",
    fieldLabel: "BSC Schedule Name",
    type: "text",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [5, 14],
  },
  {
    section: "Section 1",
    name: "bscDescription",
    label: "Description",
    fieldLabel: "BSC Description",
    type: "text",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: {
        value: 40,
        message: "Cannot exceed more than 40 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [6, 14],
  },
  {
    section: "Section 1",
    name: "bscDispOutdatedRcds",
    label: "Display",
    fieldLabel: "DSC Disp Outdated Rcds?",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 14],
  },
  {
    section: "Section 1",
    name: "bscBasis",
    label: "Basis",
    fieldLabel: "BSC Basis",
    type: "dropdown",
    dropdownCondition: "*Valid values",
    options: {
      required: { value: true, message: "Value required" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 14],
  },
  {
    section: "Section 1",
    name: "wrkNumber",
    label: "Steps",
    fieldLabel: "Wrk Number",
    type: "number",
    options: {},
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [9, 14],
  },
  {
    section: "Section 1",
    name: "planCode",
    label: "Member Override Plan",
    fieldLabel: "Plan Code",
    type: "lookup",
    externalProgram: { default: "RCPLN018" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          { source: "planCode", target: "planCode",legacy:"planCode" },
          { source: "planEffDate", 
            resolver:"formatDateForPresto",
            legacy:"planEffDate",
            target: "planEffDate" },
          { source: "planName", target: "planName",legacy:"planName" },
        ],
      },
      appName: "ACCUMS",
      pageName: "PLAN_CODE",
    },
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 28],
  },
  {
    section: "Section 1",
    name: "planName",
    label: "",
    fieldLabel: "Plan Name",
    type: "text",
    options: {},
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [11, 40],
  },
  {
    section: "Section 1",
    name: "planEffDate",
    label: "Plan From Date",
    fieldLabel: "Plan Eff Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [13, 28],
  },
  {
    section: "Audit Fields",
    section: "Audit Fields",
    name: "addedDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [19, 20],
  },
  {
    section: "Audit Fields",
    section: "Audit Fields",
    name: "changedDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [19, 40],
  },
  {
    section: "Audit Fields",
    section: "Audit Fields",
    name: "changedUser",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [19, 57],
  },
  {
    section: "Audit Fields",
    section: "Audit Fields",
    name: "noteExistenceStatus",
    label: "Note Exists",
    fieldLabel: "Note Existence Status",
    type: "text",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [19, 77],
  },
];

export const screenInfo = {
  ADD: ["Add Benefit Max Schedule", "RCBSC003"],
  CHANGE: ["Benefit Max Schedule Detail", "RCBSC002"],
  VIEW: ["Benefit Max Schedule Detail", "RCBSC002"],
};
